// extracted by mini-css-extract-plugin
module.exports = {"section":"one-news-view_section__b158H","wrapper":"one-news-view_wrapper__2Iu1M","offers":"one-news-view_offers__eTd88"};